import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import NavButton from '../homepage/header-banner/TopNavButton';
import Footer from '../homepage/footer/Footer';
import './hanbirovn.css';
import '../Style/typo.css'
import { Check } from '@mui/icons-material';
import { ChevronRight } from "@mui/icons-material";
import { ArrowRightAlt } from "@mui/icons-material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import EmailIcon from '@mui/icons-material/Email';
import ForumIcon from '@mui/icons-material/Forum';
import PhoneIcon from '@mui/icons-material/Phone';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DnsIcon from '@mui/icons-material/Dns';
import GroupsIcon from '@mui/icons-material/Groups';
import ApartmentIcon from '@mui/icons-material/Apartment';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";
import HeaderVn from "../detailpageVN/Page/component/headervn";
import useIsMobile from "../container/Sidebar/useIsMobile";
import GroupIcon from '@mui/icons-material/Group';
import LazyMap from "../container/component/map/lazymap";
import FooterVn from "../detailpageVN/Page/component/footervn";
import styled from "styled-components";

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const section = document.querySelector(location.hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return null;
};

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

function HanbiroVn() {
    const isMobile = useIsMobile();
    const [activated, setActivated] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setActivated(false);
                    setTimeout(() => setActivated(true), 200);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const CountUp = ({ start, end, duration, activated }) => {
        const [count, setCount] = useState(start);

        useEffect(() => {
            if (activated) {
                setCount(start);
                let current = start;
                const step = (end - start) / (duration * 60);

                const interval = setInterval(() => {
                    current += step;
                    if (current >= end) {
                        setCount(end);
                        clearInterval(interval);
                    } else {
                        setCount(Math.ceil(current));
                    }
                }, 1000 / 60);

                return () => clearInterval(interval);
            }
        }, [activated, start, end, duration]);

        return <span>{count.toLocaleString()}</span>;
    };


    useEffect(() => {
        const featureBoxes = document.querySelectorAll(".feature-box-col");

        featureBoxes.forEach((featureBox) => {
            const slideContainer = featureBox.querySelector(".slides");
            const dotsContainer = featureBox.querySelector(".dots");
            if (!slideContainer || !dotsContainer) return;

            const totalSlides = slideContainer.querySelectorAll("img").length;
            let currentIndex = 0;

            dotsContainer.innerHTML = "";

            for (let i = 0; i < totalSlides; i++) {
                const dot = document.createElement("div");
                dot.classList.add("dot");
                if (i === 0) dot.classList.add("active");
                dotsContainer.appendChild(dot);

                dot.addEventListener("click", () => {
                    currentIndex = i;
                    updateSlidePosition();
                    updateDots();
                });
            }

            const dots = dotsContainer.querySelectorAll(".dot");

            const updateSlidePosition = () => {
                const slideWidth = slideContainer.clientWidth;
                slideContainer.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
            };

            const updateDots = () => {
                dots.forEach((dot, index) => {
                    dot.classList.toggle("active", index === currentIndex);
                });
            };

            const autoSlide = () => {
                currentIndex = (currentIndex + 1) % totalSlides;
                updateSlidePosition();
                updateDots();
            };

            const interval = setInterval(autoSlide, 3000);

            const tabButtons = document.querySelectorAll('[data-bs-toggle="pill"]');
            tabButtons.forEach((tab) => {
                tab.addEventListener("click", () => {
                    currentIndex = 0;
                    updateSlidePosition();
                    updateDots();
                });
            });

            return () => clearInterval(interval);
        });
    }, []);

    return (
        <Sysfont className="hanbirovn">
            <HeaderVn />

            <ScrollToSection />
            <div className="header-ban">
                <div className="fit-block">
                    <FadeInSection>
                        <div className="header-ban-tt-wrap">
                            <div className="header-ban-tt-left">
                                <div>
                                    <p className="txt-48 wh-color mb-2">Xây dựng và vận hành <br />
                                        hệ thống IT toàn diện</p>
                                    <p className="txt-21 wh-color">Chúng tôi mang đến giải pháp IT tối ưu hóa theo nhu cầu, dựa trên
                                        nền
                                        tảng đám mây linh hoạt, giúp doanh nghiệp xử lý trọn gói từ hạ tầng, phần mềm, phần cứng
                                        đến
                                        tích hợp AI cộng tác</p>
                                </div>
                                <div className="group-button">
                                    <button className="btn-custom btn-emp txt-14">
                                        <a className="url-btn"
                                            href="https://www.hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">
                                            Dùng thử Groupware
                                        </a>
                                    </button>
                                    {/* <button className="btn-custom btn-emp txt-14">
                                        <a className="url-btn" href="https://www.hanbiro.com/application/index.html?Manage=mt1">
                                            Đăng ký dịch vụ Cloud
                                        </a>
                                    </button> */}
                                </div>
                            </div>
                            <div className="header-ban-tt-right">
                                <Link to="#ai-feature2" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <p className="ban-tt-text fw-600 wh-color">Giải pháp Groupware tích hợp AI</p>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <p className="ban-tt-text fw-600 wh-color">Quản lý & vận hành Cloud/Server</p>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <p className="ban-tt-text fw-600 wh-color">Giải pháp hạ tầng Kubernetes riêng</p>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <p className="ban-tt-text fw-600 wh-color">Xây dựng hạ tầng LLM tùy chỉnh</p>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <p className="ban-tt-text fw-600 wh-color">Cung cấp API Microservices Cloud</p>
                                </Link>
                            </div>
                        </div>
                    </FadeInSection>


                </div>
            </div>

            <div className="wrap-block ai-LLM" id="ai-LLM">
                <FadeInSection>
                    <div className="fit-block">
                        <div className="wrap-block-tt">
                            <p className="txt-32-sm">Giải pháp Groupware tích hợp trí tuệ nhân tạo</p>
                            <p className="txt-21-mb">AI & LLM doanh nghiệp • Vận hành server / Cam kết bảo vệ dữ liệu khách hàng</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="fea-dt-col">
                                <div className="fea-dt-row">
                                    <div className="fea-dt-item">
                                        <EmailIcon className="fea-icon" />
                                        <div>
                                            <p className="txt-21-sm fw-600">Email</p>
                                            <p className="txt-14">Tóm tắt · Dịch thuật · Gợi ý nội dung email</p>
                                        </div>
                                    </div>
                                    <div className="fea-dt-item">
                                        <ForumIcon className="fea-icon" />
                                        <div>
                                            <p className="txt-21-sm fw-600">Messenger</p>
                                            <div>
                                                <p className="txt-14">Dịch tự động·Gửi tin nhắn</p>
                                                <p className="txt-14">Tóm tắt · Dịch hội thoại</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fea-dt-item">
                                        <PhoneIcon className="fea-icon" />
                                        <div>
                                            <p className="txt-21-sm fw-600">AI Call +</p>
                                            <p className="txt-14">Tách giọng nói · Tóm tắt · Dịch thuật</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="fea-dt-row">
                                    <div className="fea-dt-item">
                                        <RequestPageIcon className="fea-icon" />
                                        <div>
                                            <p className="txt-21-sm fw-600">Phê duyệt</p>
                                            <p className="txt-14">Tóm tắt · Dịch thuật · Soạn thảo sơ bộ</p>
                                        </div>
                                    </div>
                                    <div className="fea-dt-item">
                                        <ConfirmationNumberIcon className="fea-icon" />
                                        <div>
                                            <p className="txt-21-sm fw-600">Helpdesk</p>
                                            <p className="txt-14">Tóm tắt ·Dịch thuật</p>
                                        </div>
                                    </div>
                                    <div className="fea-dt-item">
                                        <FactCheckIcon className="fea-icon" />
                                        <div>
                                            <p className="txt-21-sm fw-600">Nhật ký công việc</p>
                                            <p className="txt-14">Tóm tắt · Dịch thuật</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            <div className="wrap-block groupware-vn" id="groupware">
                <FadeInSection>
                    <div className="fit-block">
                        <div className="wrap-block-tt">
                            <div className="txt-32">Groupware</div>
                        </div>

                        <div className="groupware-vn-ct">
                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link fw-600 active" id="pills-fea1-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-fea1" type="button" role="tab" aria-controls="pills-fea1"
                                        aria-selected="true">Email</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link fw-600" id="pills-fea2-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-fea2" type="button" role="tab" aria-controls="pills-fea2"
                                        aria-selected="false">Messenger</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link fw-600" id="pills-fea3-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-fea3" type="button" role="tab" aria-controls="pills-fea3"
                                        aria-selected="false">Helpdesk</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link fw-600" id="pills-fea4-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-fea4" type="button" role="tab" aria-controls="pills-fea4"
                                        aria-selected="false">Phê duyệt</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link fw-600" id="pills-fea5-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-fea5" type="button" role="tab" aria-controls="pills-fea5"
                                        aria-selected="false">Nhân sự</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link fw-600" id="pills-fea6-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-fea6" type="button" role="tab" aria-controls="pills-fea6"
                                        aria-selected="false">Quản lý dự án</button>
                                </li>
                            </ul>
                            <div className="gw-menu-block gw-menu-block-tab">
                                <div className="menu-line">
                                    <p className="gw-menu-item txt-14">Lịch</p>
                                    <p className="gw-menu-item txt-14">Danh bạ</p>
                                    <p className="gw-menu-item txt-14">Bảng tin</p>
                                    <p className="gw-menu-item txt-14">Ghi chú</p>
                                    <p className="gw-menu-item txt-14">Clouddisk</p>
                                    <p className="gw-menu-item txt-14">Công văn</p>
                                    <p className="gw-menu-item txt-14">Todo</p>
                                    <p className="gw-menu-item txt-14">Lưu trữ</p>
                                    <p className="gw-menu-item txt-14">Tài sản</p>
                                    <p className="gw-menu-item txt-14">Báo cáo chi phí</p>
                                </div>
                            </div>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane show active" id="pills-fea1" role="tabpanel"
                                    aria-labelledby="pills-fea1-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="txt-21-mb fw-600">Lọc Email & Thư rác</p>
                                            <div className="sub-tt">
                                                <p className="txt-14 txt-color">Cung cấp chức năng dịch thuật và tóm tắt dựa
                                                    trên AI</p>
                                                <p className="txt-14 txt-color">Bộ lọc thư rác được tích hợp sẵn trong hệ thống
                                                    Groupware</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">SPF, DKIM, DMARC</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Hỗ trợ POP3/IMAP, chặn đến 95% thư rác</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Email bảo mật, Email phê duyệt, Email hàng
                                                        loạt</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Tích hợp email bên ngoài, chia sẻ hộp thư
                                                        (bao gồm nhân viên đã nghỉ)</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Chia sẻ và chuyển tiếp email của nhân viên
                                                        đã nghỉ</p>
                                                </div>
                                            </div>

                                            <div className="group-button">
                                                <button className="btn-custom btn-fill txt-14"><a className="url-btn"
                                                    href="https://hanbiro.com/software/mail-free-trial.html?SM=SPCMLKO">Đăng
                                                    ký dùng thử</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    <img src="https://hanbiro.vn/images/mail-ai-summary-vi-sm.png"
                                                        alt="Slide 1" />
                                                    <img src="https://hanbiro.vn/images/ai-call-vi-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.vn/images/mail-spam-settings-vi-sm.png"
                                                        alt="Slide 3" />
                                                    <img src="https://hanbiro.vn/images/project-view-task-vi-sm.png"
                                                        alt="Slide 4" />
                                                    <img src="https://hanbiro.vn/images/work-diary-ai-summary-vi-sm.png"
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea2" role="tabpanel" aria-labelledby="pills-fea2-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="txt-21-mb fw-600">Trò chuyện & Cuộc họp trực tuyến</p>
                                            <div className="sub-tt">
                                                <p className="txt-14 txt-color">Giao tiếp thời gian thực linh hoạt với các
                                                    thành viên trong nhóm.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Tóm tắt và dịch nội dung cuộc họp trực
                                                        tuyến</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Dịch hội thoại trực tiếp • Tóm tắt cuộc trò
                                                        chuyện trong ngày</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Hỗ trợ cộng tác công việc qua chia sẻ màn
                                                        hình, gọi thoại và họp trực tuyến</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Cho phép mời khách tham gia cuộc họp trực
                                                        tuyến.</p>
                                                </div>
                                            </div>

                                            <div className="group-button">
                                                <button className="btn-custom btn-fill txt-14"><a className="url-btn"
                                                    href="https://hanbiro.com/software/messenger-free-trial.html?SM=SPCMM">Đăng
                                                    ký dùng thử</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    <img src="https://hanbiro.vn/images/mail-ai-summary-vi-sm.png"
                                                        alt="Slide 1" />
                                                    <img src="https://hanbiro.vn/images/ai-call-vi-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.vn/images/mail-spam-settings-vi-sm.png"
                                                        alt="Slide 3" />
                                                    <img src="https://hanbiro.vn/images/project-view-task-vi-sm.png"
                                                        alt="Slide 4" />
                                                    <img src="https://hanbiro.vn/images/work-diary-ai-summary-vi-sm.png"
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea3" role="tabpanel" aria-labelledby="pills-fea3-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <div className="fea-sub-tt">
                                                <p className="txt-21-mb fw-600">Ticket</p>
                                                <div>
                                                    <p className="txt-14 txt-color">Tổng hợp và quản lý mọi yêu cầu khách hàng
                                                        trên một nền tảng duy nhất.</p>
                                                    <p className="txt-14 txt-color">Theo dõi và hỗ trợ toàn bộ quy trình từ lúc
                                                        tiếp nhận đến khi phản hồi cuối cùng được gửi đi.</p>
                                                </div>
                                            </div>

                                            <div>
                                                <p className="txt-21-mb fw-600">AI call +</p>
                                                <div>
                                                    <p className="txt-14 txt-color">Lưu trữ và phân tích lịch sử cuộc gọi với
                                                        khách hàng.</p>
                                                    <p className="txt-14 txt-color">Nâng cao chất lượng dịch vụ dựa trên thông
                                                        tin cuộc gọi và dữ liệu liên quan.</p>
                                                    <p className="txt-14 txt-color">Tóm tắt và dịch nội dung cuộc gọi bằng AI.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="group-button">
                                                <button className="btn-custom btn-fill txt-14"><a className="url-btn"
                                                    href="https://hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">Đăng
                                                    ký dùng thử</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    <img src="https://hanbiro.vn/images/mail-ai-summary-vi-sm.png"
                                                        alt="Slide 1" />
                                                    <img src="https://hanbiro.vn/images/ai-call-vi-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.vn/images/mail-spam-settings-vi-sm.png"
                                                        alt="Slide 3" />
                                                    <img src="https://hanbiro.vn/images/project-view-task-vi-sm.png"
                                                        alt="Slide 4" />
                                                    <img src="https://hanbiro.vn/images/work-diary-ai-summary-vi-sm.png"
                                                        alt="Slide 5" />
                                                </div>

                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea4" role="tabpanel" aria-labelledby="pills-fea4-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="txt-21-mb fw-600">Phê duyệt</p>
                                            <div className="sub-tt">
                                                <p className="txt-14 txt-color">Thực hiện quy trình phê duyệt mọi lúc,
                                                    mọi nơi qua PC hoặc thiết bị di động, giúp xử lý công việc nhanh chóng
                                                    và
                                                    hiệu quả.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Cung cấp miễn phí khoảng 300 biểu mẫu cơ
                                                        bản</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Hỗ trợ công thức tự động và tính toán đơn
                                                        giản với Excel editor</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Tăng cường bảo mật với quy trình phê duyệt
                                                        hai lớp</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Thiết lập và lưu phê duyệt riêng cho từng
                                                        biểu mẫu</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Liên kết hệ thống ERP, SAP và các hệ thống
                                                        quản lý nội bộ khác</p>
                                                </div>
                                            </div>

                                            <div className="group-button">
                                                <button className="btn-custom btn-fill txt-14"><a className="url-btn"
                                                    href="https://hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">Đăng
                                                    ký dùng thử</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    <img src="https://hanbiro.vn/images/mail-ai-summary-vi-sm.png"
                                                        alt="Slide 1" />
                                                    <img src="https://hanbiro.vn/images/ai-call-vi-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.vn/images/mail-spam-settings-vi-sm.png"
                                                        alt="Slide 3" />
                                                    <img src="https://hanbiro.vn/images/project-view-task-vi-sm.png"
                                                        alt="Slide 4" />
                                                    <img src="https://hanbiro.vn/images/work-diary-ai-summary-vi-sm.png"
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea5" role="tabpanel" aria-labelledby="pills-fea5-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="txt-21-mb fw-600">Quản lý chấm công & nghỉ phép</p>
                                            <div className="sub-tt">
                                                <p className="txt-14 txt-color">Hỗ trợ đa dạng hình thức làm việc: cố định,
                                                    linh hoạt,... Tự động hóa việc quản lý ngày nghỉ giúp kiểm soát giờ
                                                    ra/vào
                                                    và ngày nghỉ của nhân viên.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Chấm công qua di động bằng GPS, WiFi hoặc
                                                        Beacon</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Cung cấp chức năng phê duyệt chấm công</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Xuất báo cáo theo ngày/tuần/tháng dưới dạng
                                                        Excel</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Theo dõi tình trạng chấm công và nghỉ phép
                                                        của nhân viên qua Dashboard</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Tự động quản lý ngày phép và hỗ trợ chế độ
                                                        khuyến khích sử dụng ngày nghỉ</p>
                                                </div>
                                            </div>

                                            <div className="group-button">
                                                <button className="btn-custom btn-fill txt-14"><a className="url-btn"
                                                    href="https://hanbiro.com/software/hanbiro-hr-free-trial.html?SM=MOBILEPUNCHIN">Đăng
                                                    ký dùng thử</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    <img src="https://hanbiro.vn/images/mail-ai-summary-vi-sm.png"
                                                        alt="Slide 1" />
                                                    <img src="https://hanbiro.vn/images/ai-call-vi-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.vn/images/mail-spam-settings-vi-sm.png"
                                                        alt="Slide 3" />
                                                    <img src="https://hanbiro.vn/images/project-view-task-vi-sm.png"
                                                        alt="Slide 4" />
                                                    <img src="https://hanbiro.vn/images/work-diary-ai-summary-vi-sm.png"
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="pills-fea6" role="tabpanel" aria-labelledby="pills-fea6-tab">
                                    <div className="feature-box">
                                        <div className="feature-box-col">
                                            <p className="txt-21-mb fw-600">Quản lý Dự án</p>
                                            <div className="sub-tt">
                                                <p className="txt-14 txt-color">Tạo mẫu công việc phù hợp với doanh nghiệp,
                                                    phân công người phụ trách, giúp quản lý tiến độ một cách khoa học và
                                                    hiệu
                                                    quả.</p>
                                            </div>

                                            <div className="feature-box-text">
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Tùy chỉnh quy trình làm việc theo đặc thù
                                                        của từng công ty</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Phân công rõ ràng, tránh chồng chéo và đảm
                                                        bảo công việc diễn ra trôi chảy</p>
                                                </div>
                                                <div className="block-li">
                                                    <Check className="check" />
                                                    <p className="txt-14 txt-color">Cập nhật thay đổi tức thì, giúp nắm bắt
                                                        tiến độ công việc theo thời gian thực</p>
                                                </div>
                                            </div>

                                            <div className="group-button">
                                                <button className="btn-custom btn-fill txt-14"><a className="url-btn"
                                                    href="https://hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">Đăng
                                                    ký dùng thử</a></button>
                                            </div>
                                        </div>
                                        <div className="feature-box-col">
                                            <div className="feature-box-img feature-shadow">
                                                <div className="slides">
                                                    <img src="https://hanbiro.vn/images/mail-ai-summary-vi-sm.png"
                                                        alt="Slide 1" />
                                                    <img src="https://hanbiro.vn/images/ai-call-vi-sm.png" alt="Slide 2" />
                                                    <img src="https://hanbiro.vn/images/mail-spam-settings-vi-sm.png"
                                                        alt="Slide 3" />
                                                    <img src="https://hanbiro.vn/images/project-view-task-vi-sm.png"
                                                        alt="Slide 4" />
                                                    <img src="https://hanbiro.vn/images/work-diary-ai-summary-vi-sm.png"
                                                        alt="Slide 5" />
                                                </div>
                                            </div>
                                            <div className="dots"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="menu-block">
                                <div className="menu-line">
                                    <p className="menu-item txt-14"><b>Hỗ trợ đa ngôn ngữ</b></p>
                                    <p className="menu-item txt-14"><b>Tích hợp ERP - SAP</b></p>
                                    <p className="menu-item txt-14"><b>iOS</b></p>
                                    <p className="menu-item txt-14"><b>Tích hợp AI</b></p>
                                    <p className="menu-item txt-14"><b>Android</b></p>
                                    <p className="menu-item txt-14"><b>Linux</b></p>
                                    <p className="menu-item txt-14"><b>Mobile - Tablet</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            <div className='wrap-block global-fea1' id="services">
                <FadeInSection>
                    <div className='fit-block'>
                        <div className="wrap-block-tt">
                            <p className="txt-32">Các dịch vụ khác</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="global-fea1-block">
                                <div className='wrap-content-fea1'>
                                    <div className='wrap-ct-box' id="ai-call">
                                        <div className='wrap-item'>
                                            <p className='fea-title txt-21 fw-600'>Xây dựng và quản lý hạ tầng Kubernetes Cluster
                                            </p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='txt-14'>Quản lý và tối ưu tài nguyên máy chủ tự động và hiệu quả
                                                    </p>
                                                    <p className='txt-14'>Tự động khôi phục và mở rộng (Auto Scaling), đảm bảo dịch
                                                        vụ luôn ổn định</p>
                                                    <p className='txt-14'>Xây dựng và bảo mật hạ tầng Private Cluster cho doanh
                                                        nghiệp</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/kube-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='wrap-ct-box' id="server">
                                        <div className='wrap-item'>
                                            <p className='fea-title txt-21 fw-600'>Quản lý và vận hành máy chủ Cloud</p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='txt-14'>Giám sát máy chủ liên tục 24 giờ</p>
                                                    <p className='txt-14'>Quản lý và hỗ trợ vận hành từ các kỹ sư chuyên nghiệp</p>
                                                    <p className='txt-14'>Kinh nghiệm quản lý và vận hành hơn 8.000 máy chủ</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/server-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='wrap-content-fea1'>
                                    <div className='wrap-ct-box' id="kubernetes">
                                        <div className='wrap-item'>
                                            <p className='fea-title txt-21 fw-600'>Dịch vụ API Microservices trên nền tảng Cloud</p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='txt-14'>Xây dựng kiến trúc phân tán dựa trên sự kiện và hệ thống
                                                        không
                                                        máy chủ</p>
                                                    <p className='txt-14'>Kiểm soát truy cập an toàn với IAM, OAuth và quản lý ủy
                                                        quyền
                                                        theo vai trò</p>
                                                    <p className='txt-14'>Hỗ trợ tự động hóa sự kiện (Messaging, Webhook, Scheduler)
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/microservice-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='wrap-ct-box' id="ai-groupware">
                                        <div className='wrap-item'>
                                            <p className='fea-title txt-21 fw-600'>Phát triển và quản lý cơ sở hạ tầng AI (LLM)</p>
                                            <div className='fea-content-gr'>
                                                <div className='fea-content'>
                                                    <p className='txt-14'>Xây dựng LLM tùy chỉnh, cơ sở hạ tầng AI độc lập</p>
                                                    <p className='txt-14'>Ngăn chặn rò rỉ dữ liệu doanh nghiệp, bảo vệ dữ liệu khách
                                                        hàng
                                                    </p>
                                                    <p className='txt-14'>Quản lý và tối ưu hóa mô hình LLM của doanh nghiệp</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='wrap-item'>
                                            <div className='wrap-item-img'>
                                                <img
                                                    src="https://hanbiro.com/assets/images/cloud/hanbiro-global/llm-server-rectangle-2.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </FadeInSection>
            </div>

            <div className="wrap-block company-vn">
                <FadeInSection>
                    <div className="fit-block">
                        <div className="wrap-block-tt">
                            <p className="txt-32">Sơ đồ tổ chức các bộ phận</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="company-block">
                                <div className="company-box">
                                    <div className="company-item">
                                        <div>
                                            <p className="txt-21-mb fw-600">Microservice</p>
                                            <p className="txt-14 txt-color">12 thành viên</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="txt-21-mb fw-600">Mobile</p>
                                            <p className="txt-14 txt-color">7 thành viên</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="txt-21-mb fw-600">Phát triển phần mềm</p>
                                            <p className="txt-14 txt-color">17 thành viên</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                </div>
                                <div className="company-box">
                                    <div className="company-item">
                                        <div>
                                            <p className="txt-21-mb fw-600">Groupware</p>
                                            <p className="txt-14 txt-color">12 thành viên</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="txt-21-mb fw-600">Cloud</p>
                                            <p className="txt-14 txt-color">15 thành viên</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                    <div className="company-item">
                                        <div>
                                            <p className="txt-21-mb fw-600">Kế hoạch / QC</p>
                                            <p className="txt-14 txt-color">6 thành viên</p>
                                        </div>
                                        <div className="icon-item-gr">
                                            <GroupIcon className="icon-item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            <div className='wrap-block activity-vn'>
                <FadeInSection>
                    <div className='fit-block'>
                        <div className="wrap-block-tt">
                            <p className="txt-32">Hoạt động công ty</p>
                        </div>

                        <div className="wrap-block-ct">
                            <div className="activity-block">
                                <div className="activity-box">
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 7.png" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 6.svg" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 2.svg" />
                                    </div>
                                </div>

                                <div className="activity-box">
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 8.png" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 3.svg" />
                                    </div>
                                    <div className="activity-item">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 4.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>

            <div className='wrap-box global-fea4' id="contact">
                <div className='fit-box'>
                    <div className="wrap-title">
                        <p className="typo-32">Địa chỉ văn phòng và IDC</p>
                    </div>

                    <div className='wrap-content'>
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link typo-21 typo-medium active" id="pills-address1-tab" data-bs-toggle="pill" data-bs-target="#pills-address1" type="button" role="tab" aria-controls="pills-address1" aria-selected="true">Hàn Quốc</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link typo-21 typo-medium" id="pills-address2-tab" data-bs-toggle="pill" data-bs-target="#pills-address2" type="button" role="tab" aria-controls="pills-address2" aria-selected="false">Việt Nam</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link typo-21 typo-medium" id="pills-address3-tab" data-bs-toggle="pill" data-bs-target="#pills-address3" type="button" role="tab" aria-controls="pills-address3" aria-selected="false">Mỹ</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link typo-21 typo-medium" id="pills-address4-tab" data-bs-toggle="pill" data-bs-target="#pills-address4" type="button" role="tab" aria-controls="pills-address4" aria-selected="false">Trung Quốc</button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane show active" id="pills-address1" role="tabpanel" aria-labelledby="pills-address1-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4361.561761682642!2d127.01746401242656!3d37.4831791719437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca13e403a11a1%3A0x9c70026c0f395dc6!2s9%20Nambusunhwan-ro%20333-gil%2C%20Seocho%20District%2C%20Seoul%2C%20H%C3%A0n%20Qu%E1%BB%91c!5e1!3m2!1svi!2sus!4v1745909493964!5m2!1svi!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>Văn phòng</p>
                                            <p className='typo-14'>Địa chỉ : Tầng 4 và tầng 5, số 9 Nambusunhwan-ro 333-gil, Seocho-gu, Seoul (Tòa nhà Hyocheon)</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4361.554861606037!2d127.01955981242632!3d37.48329737194362!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca13ee3ab0e51%3A0xbddf9d0fc3e06c55!2s2481%20Nambusunhwan-ro%2C%20Seocho%20District%2C%20Seoul%2C%20H%C3%A0n%20Qu%E1%BB%91c!5e1!3m2!1svi!2sus!4v1745909721452!5m2!1svi!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : Trung tâm LG U+ Seocho</p>
                                            <p className='typo-14'>Địa chỉ : Trung tâm KIDC Seocho 1, 2481 Nambusunhwan-ro, Seocho-gu, Seoul</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4361.62226206705!2d126.87727481242634!3d37.482142771943984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9e1d58ec5037%3A0x9024f7fea8edc505!2s189%20Gasan%20digital%201-ro%2C%20Geumcheon%20District%2C%20Seoul%2C%20H%C3%A0n%20Qu%E1%BB%91c!5e1!3m2!1svi!2sus!4v1745909908839!5m2!1svi!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : Trung tâm LG U+ Gasan</p>
                                            <p className='typo-14'>Địa chỉ : 189 Gasan Digital 1-ro, Geumcheon-gu, Seoul</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4360.406002845336!2d127.04395221242713!3d37.50297317193869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca405c11d34ab%3A0x99d0338105cfb048!2s322%20Teheran-ro%2C%20Gangnam%20District%2C%20Seoul%2C%20H%C3%A0n%20Qu%E1%BB%91c!5e1!3m2!1svi!2sus!4v1745910064205!5m2!1svi!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : Trung tâm Sejong</p>
                                            <p className='typo-14'>Địa chỉ : Tầng 6, Tòa nhà Hyundai Marine, 137 Teheran-ro, Gangnam-gu, Seoul</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane" id="pills-address2" role="tabpanel" aria-labelledby="pills-address2-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5399.654115858495!2d106.7471928!3d10.7654564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175250006201481%3A0xec754ba5ba9f512!2sC%C3%B4ng%20ty%20TNHH%20Hanbiro%20Vi%E1%BB%87t%20Nam!5e1!3m2!1svi!2s!4v1744343219111!5m2!1svi!2s"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>Văn phòng</p>
                                            <p className='typo-14 address-2'>Phòng 106, KOTITI, đường 19C, Tân Thuận Đông, Quận 7, Hồ Chí Minh</p>
                                            <p className='typo-14'>Số điện thoại : 1800 6346</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5399.620390153095!2d106.7443389118303!3d10.767338389336622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752599f3304c4d%3A0x1bb1f9d9fb8aee11!2zRlBUIFTDom4gVGh14bqtbiAz!5e1!3m2!1svi!2sus!4v1744342307522!5m2!1svi!2sus" />

                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : FPT Telecom</p>
                                            <p className='typo-14 address-2'>Lô B3 Đ. Sáng Tạo, Tân Thuận Đông, Quận 7, Hồ Chí Minh 756200, Việt Nam</p>
                                            <p className='typo-14'>Số điện thoại : +84 873 002222</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane" id="pills-address3" role="tabpanel" aria-labelledby="pills-address3-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4553.530167040678!2d-118.29423538768364!3d34.05930827304247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c77913c33649%3A0x9d865a309dbe3937!2s711%20S%20Vermont%20Ave%20%23209%2C%20Los%20Angeles%2C%20CA%2090005!5e1!3m2!1svi!2sus!4v1744189176439!5m2!1svi!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>Văn phòng</p>
                                            <p className='typo-14'>711 S. VERMONT AVE.STE 209 LOS ANGELES, CA 90005</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane" id="pills-address4" role="tabpanel" aria-labelledby="pills-address4-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5077.319818522495!2d113.93058971201535!3d22.518589979444826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403ee392ee5cc21%3A0x7b478d5c1fc32062!2zVHJ1bmcgUXXhu5FjLCBHdWFuZyBEb25nIFNoZW5nLCBTaGVuIFpoZW4gU2hpLCBOYW4gU2hhbiBRdSwgTmFueW91LCBIYWkgRGUgU2FuIERhbywgMTk55Y-36KW_6ZeoIOmCruaUv-e8lueggTogNTE4MDY0!5e1!3m2!1svi!2sus!4v1745910374808!5m2!1svi!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>Văn phòng</p>
                                            <p className='typo-14'>Phòng 1108G, Tầng 11, Tòa nhà A, Tianli Central Business Plaza, Đường Houhai Avenue East, Quận Nanshan, Thâm Quyến</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <FooterVn />
        </Sysfont>
    )
}

export default HanbiroVn;